import type { SVGProps } from "react";
const SvgX = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1141.29 85.2929C1141.68 84.9024 1142.32 84.9024 1142.71 85.2929L1148 90.5858L1153.29 85.2929C1153.68 84.9024 1154.32 84.9024 1154.71 85.2929C1155.1 85.6834 1155.1 86.3166 1154.71 86.7071L1149.41 92L1154.71 97.2929C1155.1 97.6834 1155.1 98.3166 1154.71 98.7071C1154.32 99.0976 1153.68 99.0976 1153.29 98.7071L1148 93.4142L1142.71 98.7071C1142.32 99.0976 1141.68 99.0976 1141.29 98.7071C1140.9 98.3166 1140.9 97.6834 1141.29 97.2929L1146.59 92L1141.29 86.7071C1140.9 86.3166 1140.9 85.6834 1141.29 85.2929Z"
      fill="currentColor"
      transform="translate(-1136 -80)"
    />
  </svg>
);
export default SvgX;
